<template>
    <KhaiBaoVeDesktopVue v-if="!isMobile" />
    <KhaiBaoVeMobileVue v-if="isMobile" />
</template>
<script>
import KhaiBaoVeDesktopVue from "./Desktop/index.vue";
import KhaiBaoVeMobileVue from "./Mobile/index.vue";
export default {
    components: {
        KhaiBaoVeDesktopVue,
        KhaiBaoVeMobileVue,
    },
    computed: {
        isMobile: {
            get() {
                return this.$store.state.ManHinh.isMobile;
            },
            set(data) {
                this.$store.commit("ManHinh/Set", {
                    key: "isMobile",
                    data: data,
                });
            },
        },
    },
};
</script>
<style scoped></style>
